/*
 * @Author: huangzq
 * @Date: 2020-04-07 17:56:57
 * @Last Modified by: zhouwei
 * @Last Modified time: 2020-06-17 15:10:27
 * @Desc: 营销视频预览弹窗-mk-drawer-biz-two已改，没问题了
*/
<template>
  <div class="priview-dialog">
    <mk-drawer-biz-two
      :visible="visible"
      :append-to-body="false"
      :modal-append-to-body="false"
      :with-bottom="false"
      size="545px"
      title="预览"
      with-preview
      @open="onOpen"
      @close="onClose"
    >
      <!-- 内容区域 -->
      <mk-form
        :model="cloneMaterialData"
        label-position="right"
        label-width="90px"
        class="data-form"
      >
        <mk-form-item label="封面：">
          <mk-image
            class="cover-img"
            fit="cover"
            :src="cloneMaterialData.cover"
          />
        </mk-form-item>
        <mk-form-item label="标题：">
          {{ cloneMaterialData.title }}
        </mk-form-item>
        <mk-form-item label="摘要：">
          {{ cloneMaterialData.summary }}
        </mk-form-item>
        <mk-form-item label="关联内容：">
          {{ cloneMaterialData.extraInfo.title }}
        </mk-form-item>
        <mk-form-item label="描述文案：">
          {{ cloneMaterialData.extraInfo.desc }}
        </mk-form-item>
      </mk-form>

      <!-- 预览区域 -->
      <template slot="preview">
        <preview
          :preview-data="previewData"
          @iframe-loaded="iframeLoaded"
        />
      </template>
    </mk-drawer-biz-two>
  </div>
</template>

<script>
import MkDrawerBizTwo from '@components/mk-drawer-biz-two'
import Preview from './preview'
export default {
  name: 'PriviewDialog',
  components: { MkDrawerBizTwo, Preview },
  props: {
    // 是否显示弹窗
    visible: {
      type: Boolean,
      default: false
    },

    // 资料数据
    materialData: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data () {
    return {
      cloneMaterialData: { extraInfo: {} },
      // 预览数据
      previewData: { linkUrl: '' },
      // iframe加载完成后，返回的iframe的Dom元素
      previewIframeDom: null
    }
  },
  created () {},
  methods: {
    // 弹窗-取消按钮事件：关闭预览和设置弹窗
    onClose () {
      if (this.visible) {
        this.$emit('update:visible', false)
      }
    },
    // 弹窗打开时，赋值最新的营销资料的数据
    onOpen () {
      this.previewIframeDom = null
      this.cloneMaterialData = this._.cloneDeep(this.materialData)
      this.createIframeSrc()
    },
    // 生成iframe的src
    async createIframeSrc () {
      let { linkUrl } = await this.util.createH5Url(this.cloneMaterialData, 'video-markting', this.$projectScene, false)
      linkUrl += '&iframeData=yes'
      this.previewData.linkUrl = linkUrl
    },
    // iframe加载完毕后的处理
    iframeLoaded (previewIframeDom) {
      this.previewIframeDom = previewIframeDom
      this.iframePostDataMessage()
    },

    // 通过iframe进行【值】传值
    iframePostDataMessage () {
      this.previewIframeDom.contentWindow.postMessage({
        postType: 'data',
        postData: {
          videoInfo: this.cloneMaterialData,
          likeInfo: {
            isLike: 0,
            isReport: false,
            time: '',
            total: 0
          }
        }
      }, this.previewData.linkUrl)
    },

    // 通过iframe进行【事件】传递
    iframePostEventMessage (eventName) {
      this.previewIframeDom.contentWindow.postMessage({
        postType: 'event',
        postData: { eventName }
      }, this.previewData.linkUrl)
    }
  }
}
</script>

<style lang='scss' scoped>
.priview-dialog {
  & /deep/ .drawer-content {
    .data-form {
      color: #595959;

      .el-form-item__label {
        color: #000;
        font-size: 13px;
      }

      .cover-img {
        width: 160px;
        height: 160px;
      }
    }
  }
}
</style>
